import analyticsCrossProductInteractionClient, {
	type InteractionSessionTrackingOptions,
} from './analyticsCrossProductInteractionClient';
import { validProducts } from './config/productList';
import { URL_QUERY_PARAM_INTERACTION_SESSION } from './generateUrlWithParams';
import useCrossProductUrlWrapper, {
	type CrossProductUrlOptions,
} from './useCrossProductUrlWrapper';

export {
	analyticsCrossProductInteractionClient as default,
	type CrossProductUrlOptions,
	type InteractionSessionTrackingOptions,
	useCrossProductUrlWrapper,
	URL_QUERY_PARAM_INTERACTION_SESSION,
	validProducts,
};
